import type { AlertProps } from '@mui/material';
import { Alert, Card, CardContent } from '@mui/material';
import type { FC } from 'react';
import { CenterLayout } from '../page-layout/index.js';

export const AlertCard: FC<AlertProps> = (props) => (
  <CenterLayout>
    <Card>
      <CardContent>
        <Alert {...props} />
      </CardContent>
    </Card>
  </CenterLayout>
);
